export default {
  title: 'Lista de empresas nas quais aparece como usuário',
  message: `As empresas mostradas abaixo são aquelas onde você aparece como usuário. Para acessar, é necessário que possua o certificado correspondente para cada usuário. Ao clicar no ícone, a aplicação será desconectada e você será redirecionado novamente para o log-in`,
  table: {
    username: 'Usuário',
    company: 'Empresa',
    logout: 'Acessar'
  }
}